import axios from 'axios';
import { BASE_URL } from './api';

export async function createUserInteractionLog(data, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/user_interaction_logs/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}